<template>
  <div 
    class="notice" 
    ref="noticeRef"
  >
    <div class="myoppo-bar" v-if="route.name !== 'abroadList'"></div>
    <div class="notice-wrapper" v-if="filterNotice.length && showNotice">
      <div class="notice-content">
        <!-- <svg-icon
          name="icon-arrow"
          class="arrow icon-arrow-left" 
          @click="switchNotice(-1)"
          v-show="showArrow"
        /> -->
        <a 
          class="notice-text"
          :class="{
            'notice-link':`notice-${!!filterNotice[noticeIndex].link ? 'link' : ''}`,
          }"
          :href="filterNotice[noticeIndex].link" 
          :target="filterNotice[noticeIndex].target"
          v-html="filterNotice[noticeIndex].content"
        > 
        </a>
        <!-- <svg-icon
          name="icon-arrow"
          class="arrow icon-arrow-right" 
          @click="switchNotice(1)"
          v-show="showArrow"
        /> -->
      </div>
      <svg-icon name="icon-close" @click="hideAnnounce"/>
    </div>
  </div>
</template>

<script>
import setRootCssProperties from '@/utils/setRootCssProperty'

import { storeToRefs } from 'pinia'
import { useSystemStore } from '@/stores/system'
import { useNavigationStore } from '@/stores/navigation'

const HIDE_KEY = "hideAnnounceTime"

export default {
  emits: ['init'],
  props: {
    showNotice: {
      type: Boolean,
      default: true
    }
  },
  setup (props, { expose, emit }) {

    const route = useRoute()
    const systemStore = useSystemStore()
    const navigationStore = useNavigationStore()
    const { proxy } = getCurrentInstance()
    const { isApp, isOneplus, isOppoApp, isMyOppo } = storeToRefs(systemStore)   // 用户id

    const noticeRef = ref(null)

    const notice = ref([])
    const noticeIndex = ref(0)

    const showArrow = computed(() => {
      return (notice.value?.length > 1) && window.innerWidth >= 1024 
    })

    // 首页公告范围：0-全部，1-首页外，2-仅首页
    const filterNotice = computed(() => {
      const broadcastRange = route.name === 'home' ? [0, 2] : [0, 1]
      const broadcastList = notice.value.filter(i => broadcastRange.includes(i.effectiveRange))
      if (broadcastList.length) {
        getNoticeHeight()
      } else {
        let noticeHeight = 0
        if (isMyOppo.value) {
          noticeHeight += 40
        }
        navigationStore.setNoticeHeight(noticeHeight)
        setRootCssProperties({
          '--orbit-notice-height': `${noticeHeight}px`
        })
      }
      return broadcastList
    })

    function getNoticeHeight () {
      setTimeout(() => {
        let noticeHeight = noticeRef.value?.offsetHeight || 0
        if (isMyOppo.value && !noticeHeight) {
          noticeHeight += 40
        }
        navigationStore.setNoticeHeight(noticeHeight)
        setRootCssProperties({
          '--orbit-notice-height': `${noticeHeight}px`
        })
      }, 0)
    }

    // function switchNotice (step) {
    //   let newIndex = noticeIndex.value + step
    //   if (newIndex >= notice.value.length) {
    //     newIndex -= notice.value.length
    //   }
    //   if (newIndex < 0) {
    //     newIndex += notice.value.length
    //   }
    //   noticeIndex.value = newIndex
    //   getNoticeHeight()
    // }
        
    function clickNotice(link) {
      if (!link) return

      let url = new URL(link)
      if (url.host === location.host && !isApp.value) {
        // 点击公告的站内链接，只能通过路由调，不然公告会重新闪一下
        router.push({path:url.pathname})
      } else {
        window.open(link)
      }
    }

    function hideAnnounce() {
      // 用户关闭后，到当天晚上12点前都不显示
      const now = new Date();
      // 创建一个新的 Date 对象，设置为明天的 0点0分0秒
      const midnightTonight = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0, 0, 0
      );
      localStorage.setItem(HIDE_KEY, midnightTonight.getTime())
      notice.value = []
      getNoticeHeight()
    }

    function setStatusBarHeight (val) {
      setRootCssProperties({
        '--orbit-status-bar-height': val
      })
    }

    watch(route, () => {
      // 1+\oppo App 首页自定义栏目的半嵌入页不需要导航头
      if (isMyOppo.value) {
        setStatusBarHeight('40px')
      } else {
        setStatusBarHeight('0px')
      }
      getNoticeHeight()
    }, {
      immediate: true,
      deep: true
    })

    onBeforeMount(async () => {
      if (location.href.includes('abroadList')) return
      let hideTime = localStorage.getItem(HIDE_KEY)
      if (hideTime) {
        const now = new Date();
        if (hideTime > now.getTime())
        return
      }
      localStorage.removeItem(HIDE_KEY)
      // 获取公告
      let response = null
      try {
        response = JSON.parse(document.getElementById('notice-list').innerText) ?? {}
      } catch {}
      if (!response || response?.code !==200) {
        response = await proxy.$http.getNoticeList() || {}
      }
      const { code, data } = response
      if (code !== 200 || !data?.length) return
      if (code === 200 && data?.length) {
        data.forEach(i => {
          if (i.link) {
            // const url = new URL(i.link)
            i.target = i.link.includes(location.host) ? 'self' : '_blank'
          }
        })
        notice.value = [ ...data ]
      }
      // const { code, data } = await proxy.$http.getNoticeList()
      // if (code === 200 && data?.length) {
      //   data.forEach(i => {
      //     if (i.link) {
      //       const url = new URL(i.link)
      //       i.target = url.host === location.host ? 'self' : '_blank'
      //     }
      //   })
      //   notice.value = [ ...data ]
      // }
      // emit('init')
    })

    return {
      route,
      notice,
      showArrow,
      noticeRef,
      noticeIndex,
      filterNotice,
      clickNotice,
      hideAnnounce,
    }
  }
}

</script>

<style lang="postcss" scoped>
  .notice {
    --notice-font-color: var(--color-text-whitePrimary);
    position: sticky;
    top: 0;
    z-index: 1950;
    &:empty {
      padding: 0;
    }
  }
  
  .notice-wrapper {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-width: 1200px;
    padding: 12px 0;
    background-color: var(--color-infomation-default);
    animation: changeNoticeColor 0.336s ease-out 1s forwards;
  }
  .notice-content {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    width: 1160px;
    overflow: hidden;
    
  }
  .notice-text {
    width: 560px;
    text-align: center;
    word-break: break-word;
    pointer-events: none;
    color: var(--notice-font-color);
  }
  .notice-link {
    pointer-events: unset;
    &:hover {
      text-decoration: underline;
    }
  }
  .svg-icon {
    flex-shrink: 0;
    color: var(--notice-font-color);
  }
  
  .icon-arrow-left {
    transform: rotate(180deg);
    margin-right: 56px;
  }
  .icon-arrow-right {
    margin-left: 56px;
  }
  .icon-close {
    margin-left: 16px;
  }
  .myoppo-bar{
    background-color: var(--color-background-primary);
    padding: 0;
    height: var(--orbit-status-bar-height, 0px);
  }
  @media screen and (max-width: 1023px) {
    .notice-wrapper {
      min-width: unset;
      padding: 12px 18px;
      box-sizing: border-box;
    }
    .notice-content {
      justify-content: flex-start;
      padding: 0;
      font-size: 14px;
    }
    .notice-text {
      width: 100%;
      text-align: left;
    }
    .svg-icon {
      width: 20px;
      height: 20px;
    }
  }
</style>
<style>
@keyframes changeNoticeColor {
    100% {
      background-color: var(--color-background-secondary);
      --notice-font-color: var(--color-text-primary);
    }
  }
@media (max-width: 1023px) {
  .dark {
    .notice {
      --notice-font-color: #FFFFFFF2;
    }
  }
  @keyframes changeNoticeColor {
    100% {
      /* 背景色和字体颜色都要换 */
      background-color: var(--color-background-secondary);
      --notice-font-color: var(--color-text-primary);
    }
  }
}
</style>